import React, { PureComponent} from 'react';
import './Toast.scss';

export default class Toast extends PureComponent{
	render() {
		return (
			<div className={"m-page-toast " + this.props.className}>
				<div className="toast-content">{this.props.msg}</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/common/components/toast/Toast.jsx